import { render, staticRenderFns } from "./PeNotice.vue?vue&type=template&id=4f37efa2&"
import script from "./PeNotice.vue?vue&type=script&lang=js&"
export * from "./PeNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports